<template>
  <page-outline :title="$t('administration.user_edit')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
        <back-button></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <form-accordion v-else  :isTitleUpperCase="false" :title="$t('administration.user')">
        <div class="form-group">
        </div>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="login" isMandatory
              :inputLabel="$t('administration.login')" :placeholderValue="$t('administration.login')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="name" isMandatory
              :inputLabel="$t('administration.name')" :placeholderValue="$t('administration.name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <label>
              {{ $t('administration.active') }}
            </label>
            <select class="form-control" id="sel4" v-model="active" readonly>
              <option value="0"> {{ $t('administration.no') }} </option>
              <option value="1"> {{ $t('administration.in_prgrss') }} </option>
              <option value="2"> {{ $t('administration.yes') }} </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group">
            <label>{{$t('common.pwd')}}</label>
            <div class="d-flex">
              <input v-model="password"
                class="form-control inputAccordionForm h-30px"
                :type="passwordType">
                <div class="icon icon-password mt-2 pt-1 icon-field"
                  :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                  @click="switchPasswordType">
                </div>
              </input>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <label>{{$t('common.security.verif_password')}}</label>
            <div class="d-flex">
              <input v-model="passwordVerif"
                class="form-control inputAccordionForm h-30px"
                :type="passwordVerifType">
                <div class="icon icon-password mt-2 pt-1 icon-field"
                  :class="[isPasswordVerifFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                  @click="switchPasswordVerifType">
                </div>
              </input>
            </div>
          </b-col>
          <b-col cols="3" class="form-group" :key="refreshProfileList">
            <label :title="$t('administration.select_profile')">{{ $t('administration.select_profile') }}</label>
            <a id="profile-picker-link" class="combo-list-field d-flex justify-content-between"
              href="#">
              <span :class="'fixed-span-size ' + (profileDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ profileDisplay.label }}</span>
              <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
            </a>
            <b-popover target="profile-picker-link"
              :title="$t('administration.select_profile')"
              triggers="focus" placement="bottom">
              <span v-for="(profile, index) in profiles" :key="$t('common.status.rtp.' + profile.id_rights_profile) + '-' + index">
                <b-form-checkbox v-model="profile.state"
                  :value="1"
                  :unchecked-value="0">
                  <span>{{ profile.libelle }}</span>
                </b-form-checkbox>
              </span>
            </b-popover>
          </b-col>
          <b-col cols="3" class="form-group">
          </b-col>
        </b-row>
      </form-accordion>
      <b-row class="accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters">
        <b-button variant="primary"
          @click="changeUser()">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import _ from 'lodash'

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import Spinner from '@/components/common/spinner.vue'
import backButton from "@/components/common/backButton.vue"

import {loadPage, reloadPage} from '@/helpers/routing'
// import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'EditUserCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner,
    'back-button': backButton
  },
  props: ['idUserAcc', 'idCompany'],
  computed: {
    isPasswordFieldHidden () {
      return this.passwordType === 'password'
    },
    isPasswordVerifFieldHidden () {
      return this.passwordVerifType === 'password'
    },
    profileDisplay () {
      let realProfileList = this.profiles.filter(status => status.state === 1)
      if (realProfileList.length === 0) {
        return {
          label: this.$t('administration.select_profile'),
          nb: 0
        }
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map(elem => elem.libelle).join(', '),
          nb: 1
        }
      } else {
        return {
          label: this.$t('administration.selected_profile_many', {nb: realProfileList.length}),
          nb: realProfileList.length
        }
      }
    }
  },
  data () {
    return {
      activateSpinner: false,
      active: '',
      idProfile: '',
      login: '',
      name: '',
      password: '',
      passwordType: 'password',
      passwordVerif: '',
      passwordVerifType: 'password',
      profiles: [],
      refreshProfileList: false,
      Users: []
      // returnUrl: "/usercompany/" // '/detail/' + idCompany
    }
  },
  created () {
    this.profiles = this.$engine.company.profiles
    this.atStart(this.idUserAcc)
  },
  methods: {
    atStart (val = 1) {
      let that = this
      that.Users = []
      that.$engine.usercompany.getUser(
        val,
        10,
        1
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.users && resp.data.users.length > 0) {
          requests = resp.data.users[0]
          that.Users.push(requests)
          this.updateModel()
        }
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    changeUser () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let payload = {
        IdCompany: this.idCompany,
        IdUserAccount: this.idUserAcc,
        IdRightsProfile: this.profiles.filter(status => status.state === 1).map(elem => parseInt(elem.id_rights_profile)),
        UserAccount: {
          IdUser: this.idUserAcc,
          Login: this.login,
          Name: this.name,
          Active: this.active,
          Password: this.password
        }
      }
      this.$engine.usercompany.editUser(payload)
      .then(resp => {
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_user'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        that.$bus.$emit('switch-selected-menu', '/usercompany/')
        reloadPage(that, {url: /detailusercompany/ + that.idUserAcc + '/' + that.idCompany})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    },
    formHasError() {
      let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      if (this.login === undefined || this.login === '') {
        this.okMessageBox(this.$t('usercompany.missing_login'))
        return true
      }
      if (this.name === undefined || this.name === '') {
        this.okMessageBox(this.$t('usercompany.missing_name'))
        return true
      }
      if (this.passwordVerif && (this.password === undefined || this.password === '')) {
        this.okMessageBox(this.$t('errors.new_pwd_mssng'))
        return true
      }
      if (this.password && (this.passwordVerif === undefined || this.passwordVerif === '')) {
        this.okMessageBox(this.$t('usercompany.missing_password_verif'))
        return true
      }
      if (this.password && !regexPassword.test(this.password)) {
        this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
        return true
      }
      if (this.passwordVerif !== this.password) {
        this.okMessageBox(this.$t('usercompany.passwords_not_matching'))
        return true
      }
      return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchPasswordType () {
      console.log('switch', this.passwordType)
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    },
    switchPasswordVerifType () {
      console.log('switch', this.passwordVerifType)
      if (this.passwordVerifType === 'password') {
        this.passwordVerifType = 'text'
      } else {
        this.passwordVerifType = 'password'
      }
    },
    updateModel () {
      let that = this
      this.login = this.Users[0].Login
      this.active = this.Users[0].Active
      // this.type = this.Users[0].user_account.type
      this.name = this.Users[0].Name
      this.idProfile = this.Users[0].Rights && this.Users[0].Rights.length ? this.Users[0].Rights[0].IdRightProfile : ''
      this.profiles.forEach(profile => {
        if (that.Users[0].Rights.filter(item => item.IdRightProfile === profile.id_rights_profile).length) {
          profile.state = 1
        }
      })
      this.profiles = _.cloneDeep(this.profiles).sort((a, b) => {
        return a.libelle.toUpperCase() > b.libelle.toUpperCase() ? 1 : -1
      })
      this.refreshProfileList = !this.refreshProfileList
      // this.permissions = this.Users[0].user_account.permissions
      // this.activation_code = this.Users[0].user_account.activation_code
      // this.date_activate_code = this.Users[0].user_account.date_activate_code
      // this.last_account_load = this.Users[0].user_account.last_account_load
      // this.last_service_load = this.Users[0].user_account.last_service_load
      // this.is_first_login = this.Users[0].user_account.is_first_login
      // this.connect_by = this.Users[0].user_account.connect_by
    },
  }
}
</script>
